export interface ITrainingClient {
  userId: string;
  firstName: string;
  lastName: string;
  middleName: string;
  email: string;
  hasTsa: boolean;
  phone: string;
}

export class TrainingClient implements ITrainingClient {
  userId: string;
  firstName: string;
  lastName: string;
  middleName: string;
  email: string;
  hasTsa: boolean;
  phone: string;

  constructor(clone: ITrainingClient = null) {
    this.userId = '';
    this.firstName = '';
    this.lastName = '';
    this.middleName = '';
    this.email = '';
    this.hasTsa = false;
    this.phone = '';

    if (clone) {
      this.userId = clone.userId;
      this.firstName = clone.firstName;
      this.lastName = clone.lastName;
      this.middleName = clone.middleName;
      this.email = clone.email;
      this.hasTsa = clone.hasTsa;
      this.phone = clone.phone;
    }
  }
}
